// `navigator.onLine` is true on wifi with no internet, so requests would hang
// for the OS timeout (~35s) before the till falls back to offline mode. Any
// request that fails to get a response flips this flag, and later actions go
// straight to the offline path until a probe sees the server again.

const EVENT = "01pos:reachability";
let reachable = true;

export const isReachable = () => reachable;

// True when the till should behave offline right now.
export const isOffline = () => navigator.onLine === false || !reachable;

export const setReachable = (value) => {
  if (reachable === value) return;
  reachable = value;
  window.dispatchEvent(new Event(EVENT));
};

export const subscribeReachability = (fn) => {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
};

// Any HTTP response, even an error, proves the server is reachable.
export const trackReachability = (axiosInstance) =>
  axiosInstance.interceptors.response.use(
    (response) => {
      setReachable(true);
      return response;
    },
    (error) => {
      if (error?.response) setReachable(true);
      else if (error?.code === "ERR_NETWORK" || error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") {
        setReachable(false);
      }
      return Promise.reject(error);
    }
  );

// Resolves true if the server answers within `ms`; the response body is opaque
// (no-cors) because only reachability matters.
export const probeServer = async (url, ms = 5000) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  try {
    await fetch(url, {
      method: "HEAD",
      mode: "no-cors",
      cache: "no-store",
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
};
